export default __webpack_public_path__ + "static/media/agent-login.95a73bc3.png";